// extracted by mini-css-extract-plugin
export default {"loader":"bounce-loader_loader__fqpHX","bounce-loader":"bounce-loader_bounce-loader__Fscew"};